var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close($event)
        }
      }
    },
    [
      _c("div", { staticClass: "body" }, [
        _c("h2", [
          _vm._v(
            _vm._s(_vm.attendee.firstName) + " " + _vm._s(_vm.attendee.lastName)
          )
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Email")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.email))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Phone")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.phone))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Track")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.track))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Authenticated")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.authenticated))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Access Codes")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.attendee.accessCodes, function(code) {
            return _c("li", [_vm._v(_vm._s(code.code))])
          })
        ),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            staticClass: "dark",
            attrs: { type: "button", value: "Create Code" },
            on: {
              click: function($event) {
                _vm.addCode()
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04679dd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04679dd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/attendeeDetail.vue
// module id = I2vD
// module chunks = 1